import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container, Card, Form, Button } from 'react-bootstrap';
import SimplePdfViewer from '../../../hooks/usePdf'; // Assuming this hook remains the same
import { useUser } from '../../../context/UserContext';
import { updateUserAgreement } from '../../../services/authService';
import { BASE_URL } from '../../../config/apiConfig';

function AgreementCheck() {
  const { user, setUser } = useUser();
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Array to hold refs for each canvas page
  const isClientType = ['CLIENT', 'CLIENT_EMPLOYEE'].includes(user?.role_key);
  const isComplied = user?.is_complied ? parseInt(user?.is_complied) : 0;
  const currentDate = new Date();
  const userOnboardingStatus = user?.onboarding_status ? user?.onboarding_status : '';
  const contractEnd = user?.contract_end_date ? new Date(user.contract_end_date) : null;
  const trialEnd = user?.user_trial_end_date ? new Date(user.user_trial_end_date) : null;
  const isDateValid = (userOnboardingStatus == 'demo') ? true : ((userOnboardingStatus == 'live' && contractEnd && currentDate <= contractEnd) || (userOnboardingStatus == 'trial' && trialEnd && currentDate <= trialEnd));
  const filePath = `${BASE_URL}/agreements/trialUserClickAgreement.pdf`;

  // Use your custom hook to load the PDF document

  // Once the pdfDocument is available, create refs for each page and render them

  const handleCheckboxChange = (event) => setIsAgreed(event.target.checked);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isAgreed) {
      return;
    }
    try {
      const response = await updateUserAgreement();
      if (response?.data?.status === 200) {
        setUser({ ...user, is_complied: 1 });
      }
    } catch (error) {
      console.error('Submission error:', error);
    }
  };

  // console.log("isClientType : ", isClientType)

  // If user doesn't need to agree, render protected routes
  if (!isClientType || (isComplied && isDateValid)) {
    return <Outlet />;
  }

  if (isClientType && !isComplied) {
    return (
    <div style={{minHeight:"99vh",display:"flex",justifyContent:"center",alignItems:"center"}}>
      <Container className="mt-4 userAgreementContainer">
        <Card className="shadow-lg">
          <Card.Body>
            <Card.Title className="text-center   mb-4">
              Please Accept the Terms of Use
            </Card.Title>
            <SimplePdfViewer  fileUrl={filePath} scale={1.1} 
             error={error}
             setError={setError}
            />

            {/* <UserAgreementDetails/> */}

            <Form.Group className="mb-3">
              <div style={{display:"flex",justifyContent:"center",alignItems:"center", flexDirection:"column"}}> <Form.Check
                type="checkbox"
                label="I have read and agree to the terms and conditions"
                checked={isAgreed}
                onClick={handleCheckboxChange}
                disabled={!!error}
                className={`custom-checkbox-user-agreement ${error ? 'opacity-75 fw-bold' : ''} mb-4`}
              />
               <button
              onClick={handleSubmit}
              disabled={!isAgreed || !!error }
              className="agreementSubmitBtn"
            >
              Submit
            </button></div>
             
            </Form.Group>

           
          </Card.Body>
        </Card>
      </Container>
    </div>

    );
  }

  if (isClientType && !isDateValid) {

    console.log("isDateValid : ", isDateValid)
    return (
      <Container className="mt-4">
        <Card className="shadow-lg">
          <Card.Body>
            <Card.Title className="text-center mb-4">
              Contract Expired
            </Card.Title>
            <div
              className="rounded overflow-auto mb-4 d-flex justify-content-center align-items-center bg-light"
              style={{ minHeight: '30vh', position: 'relative', display: 'flex' }}
            >
              Please Contact MarketsAndMarkets Support for activation of your account
            </div>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default AgreementCheck;
